import { forwardRef } from "react";
import MaskedInput from "react-text-mask";

interface MaskedInputProps {
  [key: string]: any;
}

const CuiInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  function CuiInput(props, ref) {
    const { ...other } = props;
    return (
      <MaskedInput
        {...other}
        ref={(innerRef: any) => {
          if (!innerRef) return;

          const inputElement = innerRef.inputElement || innerRef;

          if (typeof ref === "function") {
            ref(inputElement);
          } else if (ref) {
            ref.current = inputElement;
          }
        }}
        mask={() => {
          let mask = [
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
          ];

          return mask;
        }}
        placeholderChar={"_"}
      />
    );
  }
);

export default CuiInput;
